document.addEventListener("DOMContentLoaded", function () {
  const installationsCarousel = document.querySelector(
    ".installations-carousel__carousel"
  );

  if (installationsCarousel) {
    const swiper = new Swiper(".installations-carousel__carousel", {
      direction: "horizontal",
      loop: true,
      centeredSlides: true,
      slidesPerView: "auto",
      spaceBetween: 32,
      grabCursor: false,
      breakpoints: {
        1600: {
          slidesPerView: "auto",
          // spaceBetween: 56,
          spaceBetween: 50,
        },
        1400: {
          // matches designs
          slidesPerView: 1.61,
          spaceBetween: 50,
        },
        992: {
          slidesPerView: 1.5,
          spaceBetween: 42,
        },
        768: {
          slidesPerView: 1.5,
          spaceBetween: 36,
        },
      },

      pagination: {
        el: ".swiper-pagination",
      },
    });
  }
});
